<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{ 'invest.select.title.shortLabel' | translate }}
                <app-tooltip [text]="'invest.select.title.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form *ngIf="simulations" [formGroup]="selectForm" (ngSubmit)="getInvest()">
            <mat-form-field>
                <mat-label>{{ 'invest.select.dropdown.shortLabel' | translate }}</mat-label>
                <mat-select formControlName="simulation">
                    <mat-option *ngFor="let simulation of simulations" [value]="simulation.code">
                        {{ simulation.text.shortLabel }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-raised-button color="accent" type="submit" [disabled]="!selectForm.valid">
                {{ 'invest.select.submit.shortLabel' | translate }}
            </button>
        </form>
        <mat-spinner *ngIf="!simulations" [diameter]="35" color="accent" class="spinner"></mat-spinner>
    </mat-card-content>
</mat-card>
